import { style } from '@vanilla-extract/css';

const filter = style({
  minWidth: '25.6rem',
  width: '25.6rem',
});

export const css = {
  filter,
};
